import { HTMLAttributes } from 'react'

import ColorsRows from '@/components/base/colors-rows'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'
import { useAppStore } from '@/contexts/store'
import { useSSRWishlist } from '@/hooks'
import { selectEnabledWishlist } from '@/store/wishlist'

import { cn } from '@/lib/utils'

export type WishlistProps = HTMLAttributes<HTMLDivElement>

const Wishlist = ({ className, ...props }: WishlistProps) => {
  const ssrWishlist = useSSRWishlist()
  const wishlist = selectEnabledWishlist(ssrWishlist)
  const { strings } = useAppStore()

  return wishlist.length > 0 ? (
    <ColorsRows {...props} collection={wishlist} />
  ) : (
    <Section className={cn('min-h-[50vh]', className)}>
      <Container>
        <Grid>
          <div className="col-span-2 md:col-span-6 lg:col-span-12">
            <Typography variant="history-size-body">{strings?.labels?.empty_wishlist}</Typography>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default Wishlist
